/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartCatalogSyncItemsResponse } from './PartCatalogSyncItemsResponse';
import {
    PartCatalogSyncItemsResponseFromJSON,
    PartCatalogSyncItemsResponseFromJSONTyped,
    PartCatalogSyncItemsResponseToJSON,
    PartCatalogSyncItemsResponseToJSONTyped,
} from './PartCatalogSyncItemsResponse';

/**
 * 
 * @export
 * @interface PartCatalogSyncResponse
 */
export interface PartCatalogSyncResponse {
    /**
     * 
     * @type {Date}
     * @memberof PartCatalogSyncResponse
     */
    serverTimeUtc?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof PartCatalogSyncResponse
     */
    isFullSync?: boolean;
    /**
     * 
     * @type {PartCatalogSyncItemsResponse}
     * @memberof PartCatalogSyncResponse
     */
    syncItems?: PartCatalogSyncItemsResponse;
}

/**
 * Check if a given object implements the PartCatalogSyncResponse interface.
 */
export function instanceOfPartCatalogSyncResponse(value: object): value is PartCatalogSyncResponse {
    return true;
}

export function PartCatalogSyncResponseFromJSON(json: any): PartCatalogSyncResponse {
    return PartCatalogSyncResponseFromJSONTyped(json, false);
}

export function PartCatalogSyncResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartCatalogSyncResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'serverTimeUtc': json['serverTimeUtc'] == null ? undefined : (new Date(json['serverTimeUtc'])),
        'isFullSync': json['isFullSync'] == null ? undefined : json['isFullSync'],
        'syncItems': json['syncItems'] == null ? undefined : PartCatalogSyncItemsResponseFromJSON(json['syncItems']),
    };
}

export function PartCatalogSyncResponseToJSON(json: any): PartCatalogSyncResponse {
    return PartCatalogSyncResponseToJSONTyped(json, false);
}

export function PartCatalogSyncResponseToJSONTyped(value?: PartCatalogSyncResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serverTimeUtc': value['serverTimeUtc'] == null ? undefined : ((value['serverTimeUtc']).toISOString()),
        'isFullSync': value['isFullSync'],
        'syncItems': PartCatalogSyncItemsResponseToJSON(value['syncItems']),
    };
}

